import Error from '@/common/errorData'
import CON from '../../constant'
import {
  http
} from './index'

const pasurl = CON.URL_DOWN

const getReq = (url, data) => {
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}

const postReq = (url, data) => {
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}

export default {
  // AI问答
  enhancedChat: (data) => postReq('/student-api/student/ai-qa/chat', data).then(Error),

  // 预设问答测试
  testPresetQaMatch: (data) => postReq('/student-api/student/ai-qa/preset-qa/test-match', data).then(Error),

  // 健康检查
  healthCheck: (data) => getReq('/student-api/student/ai-qa/health', data).then(Error),

  // 向量状态
  getVectorStatus: (data) => getReq('/student-api/student/ai-qa/vectors/status', data).then(Error)
}
